import pako from "pako";
import "../lib/fetch-tools"
import "../lib/fetch-tools-gold"
import _ from "lodash"
//BrowserRouter没有#   HashRouter 有#
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useState, createContext, useContext, useEffect, useRef, useCallback } from "react";
import Login from "../pages/login";
import ScrollToTop from "../components/scrollToTop";
import { homeApi } from "../api/home-api";
import { onlineApi } from "../api/online-api";
import ChangeLine from "../pages/changeLine";
import ChangeLanguage from "../pages/changelanguage";
import ChatCenter from "../pages/chatcenter";
import Register from "../pages/register";
import HomeCenter from "../pages/homecenter";
import My from "../pages/my";
import Property from "../pages/property";
import NoiceInfo from "../pages/noiceInfo";
import RechargeList from "../pages/rechargelist";
import Recharge from "../pages/recharge";
import HelpList from "../pages/helplist";
import HelpInfo from "../pages/helpinfo";
import ExtractList from "../pages/extractlist";
import Extract from "../pages/extract";
import RechargeOrderList from "../pages/rechargeorderlist";
import LockUp from "../pages/lockUp";
import LockUpInfo from "../pages/lockUpInfo";
import LockUpOrder from "../pages/lockUpOrder";
import LockUpCenter from "../pages/lockUpCenter";
import QuotationCenter from "../pages/quotation";
import JieKuan from "../pages/jiekuan";
import Chat from "../pages/chat";
import SecurityCenter from "../pages/securityCenter";
import ChangePassword from "../pages/changePassword";
import Setting from "../pages/setting";
import C2Ctx from "../pages/c2ctx";
import C2CckImage from "../pages/c2cckImage";
import C2CckInfo from "../pages/c2cckinfo";
import C2CtkList from "../pages/c2ctkList";
import C2CckList from "../pages/c2cckList";
import ExtractOrderList from "../pages/extractorderlist";
import C2CckCenter from "../pages/c2cckcenter";
import Trade from "../pages/trade";
import Idcard from "../pages/idcard";
import IdCard from "../pages/idcard";
import JYJL from "../pages/jyjlCenter";
import JYJLLever from "../pages/jyjlLever";
import JYJLTrade from "../pages/jyjlTrade";
import MarketOrderInfo from "../pages/marketOrderInfo";
import Noice from "../pages/noice";
import MurmurChat from "../pages/murmurChat";
import Address from "../pages/addressAdd";
import AddressAdd from "../pages/addressAdd";
import AddressList from "../pages/addresslist";
import Lever from "../pages/lever";
import JYJLLever2 from "../pages/jyjlLever2";
import GJIdCard from "../pages/gjidcard";
import Downland from "../pages/download";
import DownlandInfo from "../pages/downloadInfo";
import ReloadPassword from "../pages/reloadPassword";
import JieKuanList from "../pages/jiekuanList";
import JieKuanInfo from "../pages/jiekuaninfo";
import Repayment from "../pages/repayment";
import RepaymentList from "../pages/repaymentList";
import RepaymentInfo from "../pages/repaymentInfo";
import PledgeBack from "../pages/pledgeBack";
import PledgeConfirm from "../pages/pledgeConfirm";
import Acendex from "@/components/acendex";
import { AcendexHome } from "@/pages/acendex/home/index.tsx";
import { prepareColComponentToken } from "antd/es/grid/style";
//全局
export const WSContext = createContext([] as any[]);
export const WSMinContext = createContext([] as any[]);
export const LoginContext = createContext([] as any[]);
export const LoginMsgContext = createContext([] as any[]);
export const NoLoginMsgContext = createContext([] as any[]);

// 创建节流函数
const useThrottle = (fn, delay) => {
  const timer = useRef(null);
  const lastRun = useRef(0);
  
  return useCallback((...args) => {
    const now = Date.now();
    if (now - lastRun.current > delay) {
      fn(...args);
      lastRun.current = now;
    } else {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        fn(...args);
        lastRun.current = Date.now();
      }, delay);
    }
  }, [fn, delay]);
};

// 创建防抖函数
const useDebounce = (fn, delay) => {
  const timer = useRef(null);
  
  return useCallback((...args) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      fn(...args);
    }, delay);
  }, [fn, delay]);
};

// 路由验证组件
const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const uid = localStorage.getItem("uid");
    const userCode = localStorage.getItem("userCode");
    const companyId = localStorage.getItem("companyId");

    if (!uid || !userCode || !companyId) {
      navigate("/login", {
        replace: true,
        state: { from: location.pathname },
      });
    }
    setIsReady(true);
  }, [navigate, location]);

  if (!isReady) {
    return <div>Loading...</div>; // 或者你的loading组件
  }

  return <>{children}</>;
};

function filterEmptyData(data: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(data).filter(([__, value]) => !_.isEmpty(value))
  );
}

export default function AppRouter() {
  const [login, setLogin] = useState(false);
  const [loginmsg, setloginmsg] = useState({} as any);
  const [nologinmsg, setnologinmsg] = useState({} as any);
  const [ctmarketlist, setCtmarketlist] = useState([] as any[]);
  
  // 使用useRef替代普通变量，保持组件重新渲染后的引用稳定性
  const WS1 = useRef(null);
  const WS2 = useRef(null);
  const timerRef = useRef(null);
  
  const [coinListData, setCoinListData] = useState({} as any);
  const [coinListMinData, setCoinListMinData] = useState({} as any);
  
  // 使用useRef存储映射数据，避免重新渲染时丢失
  const coinListDataMapRef = useRef({} as any);
  const coinListDataMinMapRef = useRef({} as any);
  const postKDataDayRef = useRef({} as any);
  const postKDataMinRef = useRef({} as any);
  
  const isDev = process.env.NODE_ENV === "development";
  
  // 创建状态更新的节流函数，防止过于频繁更新导致无限重新渲染
  const throttledSetCoinListData = useThrottle((data) => {
    setCoinListData((pre) => ({ ...pre, ...filterEmptyData(data) }));
  }, isDev ? 10000 : 200); // 200毫秒内最多更新一次
  
  const throttledSetCoinListMinData = useThrottle((data) => {
    setCoinListMinData({...data});
  }, isDev ? 10000 : 200); // 200毫秒内最多更新一次
  
  // 定义一个延时函数
  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  
  //开始链接 wss1
  const startWS1 = useCallback(() => {
    if (WS1.current) return; // 防止重复连接
    
    WS1.current = new WebSocket("wss://api.huobi.pro/ws");
    WS1.current.onopen = async () => {
      console.info("WS1链接打开");
      for (const key in postKDataDayRef.current) {
        WS1.current.send(JSON.stringify(postKDataDayRef.current[key])); //实时
        await delay(200); // 等待200毫秒
      }
    };
    WS1.current.onclose = () => {
      console.info("WS1链接关闭");
      WS1.current = null;
    };
    WS1.current.onmessage = async (event) => {
      // 为每个消息创建一个新的FileReader实例，避免共享同一个reader导致的冲突
      const messageReader = new FileReader();
      messageReader.onload = (e) => {
        let ploydata = new Uint8Array(e.target?.result as ArrayBufferLike);
        let msg = pako.inflate(ploydata, { to: "string" });
        handleData(msg, WS1.current);
      };
      try {
        messageReader.readAsArrayBuffer(event.data);
      } catch (e) {
        console.error("WS1数据处理错误:", e);
      }
    };
    WS1.current.onerror = (error) => {
      console.error("WS1链接失败:", error);
      WS1.current = null;
      // 添加重连逻辑
      setTimeout(startWS1, 5000);
    };
  }, []);

  //开始链接 wss2
  const startWS2 = useCallback(() => {
    if (WS2.current) return; // 防止重复连接
    
    WS2.current = new WebSocket("wss://api.huobi.pro/ws");
    WS2.current.onopen = async () => {
      console.info("WS2链接打开");
      for (const key in postKDataMinRef.current) {
        WS2.current.send(JSON.stringify(postKDataMinRef.current[key])); //实时
        await delay(200); // 等待200毫秒
      }
    };
    WS2.current.onclose = () => {
      console.info("WS2链接关闭");
      WS2.current = null;
    };
    WS2.current.onmessage = async (event) => {
      // 为每个消息创建一个新的FileReader实例，避免共享同一个reader导致的冲突
      const messageReader = new FileReader();
      messageReader.onload = (e) => {
        let ploydata = new Uint8Array(e.target?.result as ArrayBufferLike);
        let msg = pako.inflate(ploydata, { to: "string" });
        handleData(msg, WS2.current);
      };
      try {
        messageReader.readAsArrayBuffer(event.data);
      } catch (e) {
        console.error("WS2数据处理错误:", e);
      }
    };
    WS2.current.onerror = (error) => {
      console.error("WS2链接失败:", error);
      WS2.current = null;
      // 添加重连逻辑
      setTimeout(startWS2, 5000);
    };
  }, []);

  // 发送响应信息
  const sendHeartMessage = useCallback((ping, WS) => {
    WS?.send(JSON.stringify({ pong: ping }));
  }, []);

  //关闭WSS1
  const closeWS1 = useCallback(() => {
    if (WS1.current) {
      WS1.current.close();
      WS1.current = null;
    }
  }, []);

  //关闭WSS2
  const closeWS2 = useCallback(() => {
    if (WS2.current) {
      WS2.current.close();
      WS2.current = null;
    }
  }, []);

  //处理响应数据
  const handleData = useCallback((msg: string, WS) => {
    try {
      let data = JSON.parse(msg);
      if (data.ping) {
        // 如果是 ping 消息
        sendHeartMessage(data.ping, WS);
      } else if (data.status === "ok") {
        //历史数据
      } else if (data.tick) {
        //eos/bch/eth
        const datat = data.tick;
        let dataUpdated = false;
        
        // 处理day数据
        for (let key in postKDataDayRef.current) {
          const baseKey = key.substring(0, key.length - 1);
          if (data.ch === `market.${baseKey}usdt.kline.1day`) {
            coinListDataMapRef.current[baseKey] = datat;
            dataUpdated = true;
            break;
          }
        }
        
        // 处理min数据
        for (let key in postKDataMinRef.current) {
          const baseKey = key.substring(0, key.length - 1);
          if (data.ch === `market.${baseKey}usdt.kline.1min`) {
            coinListDataMinMapRef.current[baseKey] = datat;
            dataUpdated = true;
            break;
          }
        }
        
        // 只有在数据实际更新时才调用setState
        if (dataUpdated) {
          throttledSetCoinListData(coinListDataMapRef.current);
          throttledSetCoinListMinData(coinListDataMinMapRef.current);
        }
      }
    } catch (error) {
      console.error("处理WebSocket数据错误:", error);
    }
  }, [sendHeartMessage]);

  const loadctmarketlistData = useCallback(async () => {
    try {
      const data = await homeApi.ctmarketlist({ pageNum: 1, pageSize: 100 });
      if (data.ok) {
        setCtmarketlist(data.data.records);
        const list = data.data.records;
        list.sort((d, e) => d.sort - e.sort);
        
        // 清空之前的数据
        coinListDataMapRef.current = {};
        postKDataDayRef.current = {};
        postKDataMinRef.current = {};
        
        for (const ctmarket of list) {
          if (ctmarket.status == 1) {
            coinListDataMapRef.current[ctmarket.coinname] = {};
            postKDataDayRef.current[ctmarket.coinname + "K"] = {
              name: ctmarket.coinname,
              sub: `market.${ctmarket.coinname}usdt.kline.1day`,
            };
            postKDataMinRef.current[ctmarket.coinname + "K"] = {
              name: ctmarket.coinname,
              sub: `market.${ctmarket.coinname}usdt.kline.1min`,
            };
          }
        }
        setCoinListData(pre => ({...pre, ...filterEmptyData(coinListDataMapRef.current)}));
        return true;
      }
      return false;
    } catch (error) {
      console.error("加载市场列表错误:", error);
      return false;
    }
  }, []);

  // 使用防抖函数包装API调用
  const debouncedLoaduserMsgData = useDebounce(async () => {
    let uid = localStorage.getItem("uid");
    uid = uid ? uid : "0";
    try {
      const data = await onlineApi.userMsg({ uid });
      if (data.ok) {
        setloginmsg(data.data?.data);
      }
    } catch (error) {
      console.error("加载用户信息错误:", error);
    }
  }, isDev ? 30000 : 300);

  const debouncedLoaduserUuidMsgData = useDebounce(async () => {
    let uuid = localStorage.getItem("murmur");
    uuid = uuid ? uuid : "0";
    try {
      const data = await onlineApi.userUuidMsg({ uuid });
      if (data.ok) {
        setnologinmsg(data.data?.data);
      }
    } catch (error) {
      console.error("加载UUID用户信息错误:", error);
    }
  }, isDev ? 30000 : 300);

  // 设置定时拉取用户信息
  useEffect(() => {
    // 初始加载
    debouncedLoaduserMsgData();
    debouncedLoaduserUuidMsgData();
    
    // 设置更长的间隔时间，避免频繁请求
    timerRef.current = setInterval(() => {
      debouncedLoaduserMsgData();
      debouncedLoaduserUuidMsgData();
    }, 10000); // 增加到10秒

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  // 加载市场数据并初始化WebSocket
  useEffect(() => {
    const initData = async () => {
      const success = await loadctmarketlistData();
      if (success) {
        startWS1();
        startWS2();
      }
    };
    
    initData();
    
    return () => {
      closeWS1();
      closeWS2();
    };
  }, [loadctmarketlistData, startWS1, startWS2, closeWS1, closeWS2]);

  // 检查登录状态
  useEffect(() => {
    const uid = localStorage.getItem("uid");
    if (uid) {
      setLogin(true);
    }
  }, []);

  return (
    <WSContext.Provider value={[coinListData, setCoinListData]}>
      <WSMinContext.Provider value={[coinListMinData, setCoinListMinData]}>
        <LoginContext.Provider value={[login, setLogin]}>
          <LoginMsgContext.Provider value={[loginmsg, setloginmsg]}>
            <NoLoginMsgContext.Provider value={[nologinmsg, setnologinmsg]}>
              <BrowserRouter>
                <ScrollToTop>
                  <Routes>
                    <Route path="/login" element={<Login />}></Route>
                    <Route path="/register" element={<Register />}></Route>
                    <Route path="/register/:code" element={<Register />}></Route>
                    <Route path="/homecenter" element={<AcendexHome />}></Route>
                    <Route path="/pledgeBack" element={<PledgeBack />}></Route>
                    <Route
                      path="/pledgeConfirm/:id"
                      element={<PledgeConfirm />}
                    ></Route>
                    <Route
                      path="/mycenter"
                      element={
                        <AuthRoute>
                          <My />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/reloadPassword"
                      element={<ReloadPassword />}
                    ></Route>
                    <Route path="/changeline" element={<ChangeLine />}></Route>
                    <Route
                      path="/propertycenter"
                      element={
                        <AuthRoute>
                          <Property />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/changelanguage"
                      element={<ChangeLanguage />}
                    ></Route>
                    <Route path="/chatcenter" element={<ChatCenter />}></Route>
                    <Route
                      path="/chat"
                      element={
                        <AuthRoute>
                          <Chat />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route path="/murmurchat" element={<MurmurChat />}></Route>
                    <Route
                      path="/securitycenter"
                      element={
                        <AuthRoute>
                          <SecurityCenter />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/changePassword"
                      element={
                        <AuthRoute>
                          <ChangePassword />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/noiceInfo"
                      element={
                        <AuthRoute>
                          <NoiceInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/extractlist"
                      element={
                        <AuthRoute>
                          <ExtractList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/extractorderlist"
                      element={
                        <AuthRoute>
                          <ExtractOrderList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/extract/:id"
                      element={
                        <AuthRoute>
                          <Extract />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/rechargelist"
                      element={
                        <AuthRoute>
                          <RechargeList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/rechargeorderlist"
                      element={
                        <AuthRoute>
                          <RechargeOrderList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/setting"
                      element={
                        <AuthRoute>
                          <Setting />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/recharge/:id"
                      element={
                        <AuthRoute>
                          <Recharge />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/helplist"
                      element={
                        <AuthRoute>
                          <HelpList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/helpinfo/:id"
                      element={
                        <AuthRoute>
                          <HelpInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/lockUpCenter"
                      element={
                        <AuthRoute>
                          <LockUpCenter />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/lockUp"
                      element={
                        <AuthRoute>
                          <LockUp />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/lockUpInfo/:id"
                      element={
                        <AuthRoute>
                          <LockUpInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/lockUpOrder"
                      element={
                        <AuthRoute>
                          <LockUpOrder />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/quotation"
                      element={
                        <AuthRoute>
                          <QuotationCenter />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/trade/:name"
                      element={
                        <AuthRoute>
                          <Trade />
                        </AuthRoute>
                      }
                    />
                    <Route
                      path="/borrowmoney"
                      element={
                        <AuthRoute>
                          <JieKuan />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/jiekuanlist"
                      element={
                        <AuthRoute>
                          <JieKuanList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/jiekuaninfo/:orderNo"
                      element={
                        <AuthRoute>
                          <JieKuanInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2cckcenter"
                      element={
                        <AuthRoute>
                          <C2CckCenter />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2cckList"
                      element={
                        <AuthRoute>
                          <C2CckList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2ctkList"
                      element={
                        <AuthRoute>
                          <C2CtkList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2cckinfo/:orderNo"
                      element={
                        <AuthRoute>
                          <C2CckInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2cckimage/:orderNo"
                      element={
                        <AuthRoute>
                          <C2CckImage />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/c2ctx/:currencyId"
                      element={
                        <AuthRoute>
                          <C2Ctx />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/idcard"
                      element={
                        <AuthRoute>
                          <IdCard />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/gjidcard"
                      element={
                        <AuthRoute>
                          <GJIdCard />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/jyjl"
                      element={
                        <AuthRoute>
                          <JYJL />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route path="/download" element={<Downland />}></Route>
                    <Route
                      path="/downloadInfo"
                      element={<DownlandInfo />}
                    ></Route>
                    <Route
                      path="/jyjlLever"
                      element={
                        <AuthRoute>
                          <JYJLLever />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/jyjlLever2"
                      element={
                        <AuthRoute>
                          <JYJLLever2 />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/jyjlTrade"
                      element={
                        <AuthRoute>
                          <JYJLTrade />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/marketOrderInfo/:id"
                      element={
                        <AuthRoute>
                          <MarketOrderInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/noice"
                      element={
                        <AuthRoute>
                          <Noice />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/addressadd"
                      element={
                        <AuthRoute>
                          <AddressAdd />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/addresslist"
                      element={
                        <AuthRoute>
                          <AddressList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/lever/:name"
                      element={
                        <AuthRoute>
                          <Lever />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/repayment/:id/:num"
                      element={
                        <AuthRoute>
                          <Repayment />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/repaymentList"
                      element={
                        <AuthRoute>
                          <RepaymentList />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="/repaymentInfo/:id"
                      element={
                        <AuthRoute>
                          <RepaymentInfo />
                        </AuthRoute>
                      }
                    ></Route>
                    <Route
                      path="*"
                      element={<Navigate to="/homecenter" />}
                    ></Route>
                  </Routes>
                  <Acendex />
                </ScrollToTop>
              </BrowserRouter>
            </NoLoginMsgContext.Provider>
          </LoginMsgContext.Provider>
        </LoginContext.Provider>
      </WSMinContext.Provider>
    </WSContext.Provider>
  );
}
